module.exports = __webpack_public_path__ + "static/media/CzymJestTestLoriini.84624715.png";